var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var pageResults = require('graph-results-pager');

var _require = require('./../constants'),
    graphAPIEndpoints = _require.graphAPIEndpoints;

var _require2 = require('./../utils'),
    timestampToBlock = _require2.timestampToBlock;

module.exports = {
  queuedTxs: function queuedTxs() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$minTimestamp, minTimestamp, _ref$maxTimestamp, maxTimestamp, _ref$minBlock, minBlock, _ref$maxBlock, maxBlock, _ref$max, max;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$minTimestamp = _ref.minTimestamp, minTimestamp = _ref$minTimestamp === void 0 ? undefined : _ref$minTimestamp, _ref$maxTimestamp = _ref.maxTimestamp, maxTimestamp = _ref$maxTimestamp === void 0 ? undefined : _ref$maxTimestamp, _ref$minBlock = _ref.minBlock, minBlock = _ref$minBlock === void 0 ? undefined : _ref$minBlock, _ref$maxBlock = _ref.maxBlock, maxBlock = _ref$maxBlock === void 0 ? undefined : _ref$maxBlock, _ref$max = _ref.max, max = _ref$max === void 0 ? undefined : _ref$max;
              _context.t0 = pageResults;
              _context.t1 = graphAPIEndpoints.timelock;
              _context.t2 = minBlock;

              if (_context.t2) {
                _context.next = 13;
                break;
              }

              if (!minTimestamp) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return timestampToBlock(minTimestamp);

            case 8:
              _context.t3 = _context.sent;
              _context.next = 12;
              break;

            case 11:
              _context.t3 = undefined;

            case 12:
              _context.t2 = _context.t3;

            case 13:
              _context.t4 = _context.t2;
              _context.t5 = maxBlock;

              if (_context.t5) {
                _context.next = 24;
                break;
              }

              if (!maxTimestamp) {
                _context.next = 22;
                break;
              }

              _context.next = 19;
              return timestampToBlock(maxTimestamp);

            case 19:
              _context.t6 = _context.sent;
              _context.next = 23;
              break;

            case 22:
              _context.t6 = undefined;

            case 23:
              _context.t5 = _context.t6;

            case 24:
              _context.t7 = _context.t5;
              _context.t8 = {
                isCanceled: false,
                isExecuted: false,
                createdBlock_gte: _context.t4,
                createdBlock_lte: _context.t7
              };
              _context.t9 = {
                where: _context.t8
              };
              _context.t10 = _queuedTxs.properties;
              _context.t11 = {
                entity: 'timelocks',
                selection: _context.t9,
                properties: _context.t10
              };
              _context.t12 = max;
              _context.t13 = {
                api: _context.t1,
                query: _context.t11,
                max: _context.t12
              };
              return _context.abrupt("return", (0, _context.t0)(_context.t13).then(function (results) {
                return _queuedTxs.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  canceledTxs: function canceledTxs() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref2, _ref2$minTimestamp, minTimestamp, _ref2$maxTimestamp, maxTimestamp, _ref2$minBlock, minBlock, _ref2$maxBlock, maxBlock, _ref2$max, max;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref2$minTimestamp = _ref2.minTimestamp, minTimestamp = _ref2$minTimestamp === void 0 ? undefined : _ref2$minTimestamp, _ref2$maxTimestamp = _ref2.maxTimestamp, maxTimestamp = _ref2$maxTimestamp === void 0 ? undefined : _ref2$maxTimestamp, _ref2$minBlock = _ref2.minBlock, minBlock = _ref2$minBlock === void 0 ? undefined : _ref2$minBlock, _ref2$maxBlock = _ref2.maxBlock, maxBlock = _ref2$maxBlock === void 0 ? undefined : _ref2$maxBlock, _ref2$max = _ref2.max, max = _ref2$max === void 0 ? undefined : _ref2$max;
              _context2.t0 = pageResults;
              _context2.t1 = graphAPIEndpoints.timelock;
              _context2.t2 = minBlock;

              if (_context2.t2) {
                _context2.next = 13;
                break;
              }

              if (!minTimestamp) {
                _context2.next = 11;
                break;
              }

              _context2.next = 8;
              return timestampToBlock(minTimestamp);

            case 8:
              _context2.t3 = _context2.sent;
              _context2.next = 12;
              break;

            case 11:
              _context2.t3 = undefined;

            case 12:
              _context2.t2 = _context2.t3;

            case 13:
              _context2.t4 = _context2.t2;
              _context2.t5 = maxBlock;

              if (_context2.t5) {
                _context2.next = 24;
                break;
              }

              if (!maxTimestamp) {
                _context2.next = 22;
                break;
              }

              _context2.next = 19;
              return timestampToBlock(maxTimestamp);

            case 19:
              _context2.t6 = _context2.sent;
              _context2.next = 23;
              break;

            case 22:
              _context2.t6 = undefined;

            case 23:
              _context2.t5 = _context2.t6;

            case 24:
              _context2.t7 = _context2.t5;
              _context2.t8 = {
                isCanceled: true,
                createdBlock_gte: _context2.t4,
                createdBlock_lte: _context2.t7
              };
              _context2.t9 = {
                where: _context2.t8
              };
              _context2.t10 = _canceledTxs.properties;
              _context2.t11 = {
                entity: 'timelocks',
                selection: _context2.t9,
                properties: _context2.t10
              };
              _context2.t12 = max;
              _context2.t13 = {
                api: _context2.t1,
                query: _context2.t11,
                max: _context2.t12
              };
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t13).then(function (results) {
                return _canceledTxs.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  executedTxs: function executedTxs() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref3, _ref3$minTimestamp, minTimestamp, _ref3$maxTimestamp, maxTimestamp, _ref3$minBlock, minBlock, _ref3$maxBlock, maxBlock, _ref3$max, max;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, _ref3$minTimestamp = _ref3.minTimestamp, minTimestamp = _ref3$minTimestamp === void 0 ? undefined : _ref3$minTimestamp, _ref3$maxTimestamp = _ref3.maxTimestamp, maxTimestamp = _ref3$maxTimestamp === void 0 ? undefined : _ref3$maxTimestamp, _ref3$minBlock = _ref3.minBlock, minBlock = _ref3$minBlock === void 0 ? undefined : _ref3$minBlock, _ref3$maxBlock = _ref3.maxBlock, maxBlock = _ref3$maxBlock === void 0 ? undefined : _ref3$maxBlock, _ref3$max = _ref3.max, max = _ref3$max === void 0 ? undefined : _ref3$max;
              _context3.t0 = pageResults;
              _context3.t1 = graphAPIEndpoints.timelock;
              _context3.t2 = minBlock;

              if (_context3.t2) {
                _context3.next = 13;
                break;
              }

              if (!minTimestamp) {
                _context3.next = 11;
                break;
              }

              _context3.next = 8;
              return timestampToBlock(minTimestamp);

            case 8:
              _context3.t3 = _context3.sent;
              _context3.next = 12;
              break;

            case 11:
              _context3.t3 = undefined;

            case 12:
              _context3.t2 = _context3.t3;

            case 13:
              _context3.t4 = _context3.t2;
              _context3.t5 = maxBlock;

              if (_context3.t5) {
                _context3.next = 24;
                break;
              }

              if (!maxTimestamp) {
                _context3.next = 22;
                break;
              }

              _context3.next = 19;
              return timestampToBlock(maxTimestamp);

            case 19:
              _context3.t6 = _context3.sent;
              _context3.next = 23;
              break;

            case 22:
              _context3.t6 = undefined;

            case 23:
              _context3.t5 = _context3.t6;

            case 24:
              _context3.t7 = _context3.t5;
              _context3.t8 = {
                isExecuted: true,
                createdBlock_gte: _context3.t4,
                createdBlock_lte: _context3.t7
              };
              _context3.t9 = {
                where: _context3.t8
              };
              _context3.t10 = _executedTxs.properties;
              _context3.t11 = {
                entity: 'timelocks',
                selection: _context3.t9,
                properties: _context3.t10
              };
              _context3.t12 = max;
              _context3.t13 = {
                api: _context3.t1,
                query: _context3.t11,
                max: _context3.t12
              };
              return _context3.abrupt("return", (0, _context3.t0)(_context3.t13).then(function (results) {
                return _executedTxs.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 32:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  allTxs: function allTxs() {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref4, _ref4$minTimestamp, minTimestamp, _ref4$maxTimestamp, maxTimestamp, _ref4$minBlock, minBlock, _ref4$maxBlock, maxBlock, _ref4$max, max;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {}, _ref4$minTimestamp = _ref4.minTimestamp, minTimestamp = _ref4$minTimestamp === void 0 ? undefined : _ref4$minTimestamp, _ref4$maxTimestamp = _ref4.maxTimestamp, maxTimestamp = _ref4$maxTimestamp === void 0 ? undefined : _ref4$maxTimestamp, _ref4$minBlock = _ref4.minBlock, minBlock = _ref4$minBlock === void 0 ? undefined : _ref4$minBlock, _ref4$maxBlock = _ref4.maxBlock, maxBlock = _ref4$maxBlock === void 0 ? undefined : _ref4$maxBlock, _ref4$max = _ref4.max, max = _ref4$max === void 0 ? undefined : _ref4$max;
              _context4.t0 = pageResults;
              _context4.t1 = graphAPIEndpoints.timelock;
              _context4.t2 = minBlock;

              if (_context4.t2) {
                _context4.next = 13;
                break;
              }

              if (!minTimestamp) {
                _context4.next = 11;
                break;
              }

              _context4.next = 8;
              return timestampToBlock(minTimestamp);

            case 8:
              _context4.t3 = _context4.sent;
              _context4.next = 12;
              break;

            case 11:
              _context4.t3 = undefined;

            case 12:
              _context4.t2 = _context4.t3;

            case 13:
              _context4.t4 = _context4.t2;
              _context4.t5 = maxBlock;

              if (_context4.t5) {
                _context4.next = 24;
                break;
              }

              if (!maxTimestamp) {
                _context4.next = 22;
                break;
              }

              _context4.next = 19;
              return timestampToBlock(maxTimestamp);

            case 19:
              _context4.t6 = _context4.sent;
              _context4.next = 23;
              break;

            case 22:
              _context4.t6 = undefined;

            case 23:
              _context4.t5 = _context4.t6;

            case 24:
              _context4.t7 = _context4.t5;
              _context4.t8 = {
                createdBlock_gte: _context4.t4,
                createdBlock_lte: _context4.t7
              };
              _context4.t9 = {
                where: _context4.t8
              };
              _context4.t10 = _allTxs.properties;
              _context4.t11 = {
                entity: 'timelocks',
                selection: _context4.t9,
                properties: _context4.t10
              };
              _context4.t12 = max;
              _context4.t13 = {
                api: _context4.t1,
                query: _context4.t11,
                max: _context4.t12
              };
              return _context4.abrupt("return", (0, _context4.t0)(_context4.t13).then(function (results) {
                return _allTxs.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 32:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};
var _queuedTxs = {
  properties: ['id', 'description', 'value', 'eta', 'functionName', 'data', 'targetAddress', 'createdBlock', 'createdTs', 'expiresTs', 'createdTx'],
  callback: function callback(results) {
    return results.map(function (_ref5) {
      var id = _ref5.id,
          description = _ref5.description,
          value = _ref5.value,
          eta = _ref5.eta,
          functionName = _ref5.functionName,
          data = _ref5.data,
          targetAddress = _ref5.targetAddress,
          createdBlock = _ref5.createdBlock,
          createdTs = _ref5.createdTs,
          expiresTs = _ref5.expiresTs,
          createdTx = _ref5.createdTx;
      return {
        txHash: id,
        description: description,
        value: Number(value),
        etaTs: Number(eta * 1000),
        etaDate: new Date(eta * 1000),
        functionName: functionName,
        data: data,
        targetAddress: targetAddress,
        createdBlock: Number(createdBlock),
        createdTs: Number(createdTs * 1000),
        createdDate: new Date(createdTs * 1000),
        expiresTs: Number(expiresTs * 1000),
        expiresDate: new Date(expiresTs * 1000),
        createdTx: createdTx
      };
    }).sort(function (a, b) {
      return b.createdBlock - a.createdBlock;
    });
  }
};
var _canceledTxs = {
  properties: ['id', 'description', 'value', 'eta', 'functionName', 'data', 'targetAddress', 'createdBlock', 'createdTs', 'expiresTs', 'canceledBlock', 'canceledTs', 'createdTx', 'canceledTx'],
  callback: function callback(results) {
    return results.map(function (_ref6) {
      var id = _ref6.id,
          description = _ref6.description,
          value = _ref6.value,
          eta = _ref6.eta,
          functionName = _ref6.functionName,
          data = _ref6.data,
          targetAddress = _ref6.targetAddress,
          createdBlock = _ref6.createdBlock,
          createdTs = _ref6.createdTs,
          expiresTs = _ref6.expiresTs,
          canceledBlock = _ref6.canceledBlock,
          canceledTs = _ref6.canceledTs,
          createdTx = _ref6.createdTx,
          canceledTx = _ref6.canceledTx;
      return {
        txHash: id,
        description: description,
        value: Number(value),
        etaTs: Number(eta * 1000),
        etaDate: new Date(eta * 1000),
        functionName: functionName,
        data: data,
        targetAddress: targetAddress,
        createdBlock: Number(createdBlock),
        createdTs: Number(createdTs * 1000),
        createdDate: new Date(createdTs * 1000),
        expiresTs: Number(expiresTs * 1000),
        expiresDate: new Date(expiresTs * 1000),
        canceledBlock: canceledTx ? Number(canceledBlock) : null,
        canceledTs: canceledTx ? Number(canceledTs * 1000) : null,
        canceledDate: canceledTx ? new Date(canceledTs * 1000) : null,
        createdTx: createdTx,
        canceledTx: canceledTx
      };
    }).sort(function (a, b) {
      return b.createdBlock - a.createdBlock;
    });
  }
};
var _executedTxs = {
  properties: ['id', 'description', 'value', 'eta', 'functionName', 'data', 'targetAddress', 'createdBlock', 'createdTs', 'expiresTs', 'executedBlock', 'executedTs', 'createdTx', 'executedTx'],
  callback: function callback(results) {
    return results.map(function (_ref7) {
      var id = _ref7.id,
          description = _ref7.description,
          value = _ref7.value,
          eta = _ref7.eta,
          functionName = _ref7.functionName,
          data = _ref7.data,
          targetAddress = _ref7.targetAddress,
          createdBlock = _ref7.createdBlock,
          createdTs = _ref7.createdTs,
          expiresTs = _ref7.expiresTs,
          executedBlock = _ref7.executedBlock,
          executedTs = _ref7.executedTs,
          createdTx = _ref7.createdTx,
          executedTx = _ref7.executedTx;
      return {
        txHash: id,
        description: description,
        value: Number(value),
        etaTs: Number(eta * 1000),
        etaDate: new Date(eta * 1000),
        functionName: functionName,
        data: data,
        targetAddress: targetAddress,
        createdBlock: Number(createdBlock),
        createdTs: Number(createdTs * 1000),
        createdDate: new Date(createdTs * 1000),
        expiresTs: Number(expiresTs * 1000),
        expiresDate: new Date(expiresTs * 1000),
        executedBlock: executedTx ? Number(executedBlock) : null,
        executedTs: executedTx ? Number(executedTs * 1000) : null,
        executedDate: executedTx ? new Date(executedTs * 1000) : null,
        createdTx: createdTx,
        executedTx: executedTx
      };
    }).sort(function (a, b) {
      return b.createdBlock - a.createdBlock;
    });
    ;
  }
};
var _allTxs = {
  properties: ['id', 'description', 'value', 'eta', 'functionName', 'data', 'targetAddress', 'isCanceled', 'isExecuted', 'createdBlock', 'createdTs', 'expiresTs', 'canceledBlock', 'canceledTs', 'executedBlock', 'executedTs', 'createdTx', 'canceledTx', 'executedTx'],
  callback: function callback(results) {
    return results.map(function (_ref8) {
      var id = _ref8.id,
          description = _ref8.description,
          value = _ref8.value,
          eta = _ref8.eta,
          functionName = _ref8.functionName,
          data = _ref8.data,
          targetAddress = _ref8.targetAddress,
          isCanceled = _ref8.isCanceled,
          isExecuted = _ref8.isExecuted,
          createdBlock = _ref8.createdBlock,
          createdTs = _ref8.createdTs,
          expiresTs = _ref8.expiresTs,
          canceledBlock = _ref8.canceledBlock,
          canceledTs = _ref8.canceledTs,
          executedBlock = _ref8.executedBlock,
          executedTs = _ref8.executedTs,
          createdTx = _ref8.createdTx,
          canceledTx = _ref8.canceledTx,
          executedTx = _ref8.executedTx;
      return {
        txHash: id,
        description: description,
        value: Number(value),
        etaTs: Number(eta * 1000),
        etaDate: new Date(eta * 1000),
        functionName: functionName,
        data: data,
        targetAddress: targetAddress,
        isCanceled: isCanceled,
        isExecuted: isExecuted,
        createdBlock: Number(createdBlock),
        createdTs: Number(createdTs * 1000),
        createdDate: new Date(createdTs * 1000),
        expiresTs: Number(expiresTs * 1000),
        expiresDate: new Date(expiresTs * 1000),
        canceledBlock: canceledTx ? Number(canceledBlock) : null,
        canceledTs: canceledTx ? Number(canceledTs * 1000) : null,
        canceledDate: canceledTx ? new Date(canceledTs * 1000) : null,
        executedTs: executedTx ? Number(executedTs * 1000) : null,
        executedDate: executedTx ? new Date(executedTs * 1000) : null,
        createdTx: createdTx,
        canceledTx: canceledTx,
        executedTx: executedTx
      };
    }).sort(function (a, b) {
      return b.createdBlock - a.createdBlock;
    });
  }
};